<template>
	<transition name="popup-view" tag="div">
		<div v-show="_modals.length > 0" class="popup-view" @click.stop="pop">
			<transition-group name="popup" tag="div" enter-to-class="popup-enter-to">
				<div :class="{
					popup: true,
					'popup-hidden': $store.getters.popups.length - 1 != i
				}" v-for="(popup, i) in _modals" :key="i" @click.stop="">
					<div class="content">
						<div class="title">{{ popup.props.title }}</div>
						<component :is="popup.component" v-bind="popup.props || {}" v-on="popup.events || {}" />
					</div>
					<div class="actions">
						<div class="action" v-for="(action, i) in popup.props.actions" :key="i" @click.stop="action.callback">{{ action.label }}</div>
					</div>
				</div>
			</transition-group>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'popup-view',
		props: {
			fragments: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		computed: {
			_modals() {
				return this.$store.getters.popups;
			},
			_modal() {
				return this.$store.getters.popups[this.$store.getters.popups.length - 1];
			}
		},
		methods: {
			pop() {
				this.$store.commit('popPopup');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.popup-view {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		/*display: grid;
		justify-items: center;
		align-items: center;*/

		& > div > .popup {
			position: absolute;
			left: 10px;
			bottom: 10px;
			right: 10px;
			transition: opacity 250ms, transform 250ms;

			& > .content {
				background-color: white;
				border-radius: 6px;
				overflow: hidden;

				& > .title {
					color: rgb(190, 190, 190);
					text-align: center;
					line-height: 40px;
					border-bottom: 1px solid rgb(238, 238, 238);
				}
			}

			& > .actions {
				& > .action {
					background-color: #F7223F;
					border-radius: 6px;
					overflow: hidden;
					margin-top: 10px;
					line-height: 48px;
					text-align: center;
					font-weight: bold;
					color: white;
					font-size: 16px;
				}
			}

			&-hidden {
				opacity: 0;
				transform: scale(0.5);
			}

			&-enter, &-leave-to {
				opacity: 0;
				transform: translateY(100px);
			}

			&-enter-to {
				opacity: 1;
			}

			&-enter-active, &-leave-active, &-hidden {
				transition: opacity 250ms, transform 250ms;
			}
		}

		&-enter, &-leave-to {
			opacity: 0;
		}

		&-enter-to {
			opacity: 1;
		}

		&-enter-active, &-leave-active {
			transition: opacity 250ms, transform 250ms;
		}
	}


</style>